import { ApiChangeEmailRequest, ApiErrorResponse, ApiUser, ApiUserUpdate } from "./api_data";
import { div, input, anchor, form, button } from "../../shared/dom";
import { SVG } from "../../shared/svg";
import { Loading } from "../../shared/loading";
import { Ajax } from "../../shared/ajax";
import { Auth } from "./auth";
import { Overlay, OverlayStyle } from "../../shared/overlay";
import { App } from "./app";
import { FilesPage } from "./files_page";

export class Settings {

  private static edit_section(title: string): HTMLElement {
    const section = div("block", title.toLowerCase().replace(/ /g, "-"));
    const title_el = div("medium", "title");
    title_el.innerText = title;
    section.appendChild(title_el);
    return section;
  }

  static render_profile_settings(user: ApiUser, container: HTMLElement) {
    const d = div("settings");
    const avatar = Settings.edit_section("Avatar");
    d.appendChild(avatar);

    const img = div("user-avatar");
    if (user.image_timestamp) {
      const url = FilesPage.avatar_url(user);
      img.style.backgroundImage = "url(" + url + ")";
    }
    avatar.appendChild(img);

    const edit_overlay = div("avatar-edit", "c-flex");
    const pencil = SVG.pencil();
    edit_overlay.appendChild(pencil);
    img.appendChild(edit_overlay);

    const loading_img = document.createElement("img");
    loading_img.classList.add("loading-img", "loading-img-light");
    loading_img.src = Loading.img_light;
    edit_overlay.appendChild(loading_img);

    const picker = input();
    picker.setAttribute("type", "file");
    picker.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
    edit_overlay.appendChild(picker);

    let img_src = "";
    picker.onchange = function () {
      const reader = new FileReader();
      const bin_reader = new FileReader();

      reader.onload = function () {
        const result = reader.result;
        if (result !== null && typeof result === 'string') {
          img_src = result;
        }
      };

      bin_reader.onload = function () {
        const result = bin_reader.result;
        if (result !== null && result instanceof ArrayBuffer) {
          const form = new FormData();
          const blob = new Blob([result], {});
          form.append("file", blob);
          edit_overlay.classList.add("loading");
          Ajax.post("/api/v1/user_avatar", function (data: ApiUser) {
            if (App.user) {
              App.user.image_timestamp = data.image_timestamp;
            }
            edit_overlay.classList.remove("loading");
            img.style.backgroundImage = "url(" + img_src + ")";
            const header_img = document.querySelector("div.fixed-header div.user-avatar") as HTMLElement;
            if (header_img) {
              const url = FilesPage.avatar_url(data);
              header_img.style.backgroundImage = "url(" + url + ")";
            }
          }, form);
        }
      };
      if (picker.files && picker.files.length > 0) {
        reader.readAsDataURL(picker.files[0]);
        bin_reader.readAsArrayBuffer(picker.files[0]);
      }
    }

    img.onclick = function () {
      picker.click();
    }

    const name_section = Settings.edit_section("Name");
    d.appendChild(name_section);

    const name_el = div();
    name_el.innerText = user.name;
    name_section.appendChild(name_el);
    const name_link = anchor("inline-block");
    name_link.innerText = "Change name";
    name_section.appendChild(name_link);

    name_link.onclick = function () {
      const body = div("overlay-body");
      new Overlay(OverlayStyle.Viz, "Change Name", [body], "", function () {
        //
      });

      const f = form();
      const name_input = Auth.input("Name", "false", "text", "");
      name_input.value = user.name;
      f.appendChild(name_input);

      const err = div("error");
      err.style.display = "none";
      f.appendChild(err);

      const button_container = div("r-align");
      const update = button("key");
      button_container.appendChild(update);
      update.setAttribute("type", "submit");
      update.innerText = "Update";
      const loading = Loading.overlay();
      update.appendChild(loading);
      f.appendChild(button_container);
      body.appendChild(f);

      f.onsubmit = function (e) {
        e.preventDefault();
        if (update.classList.contains("working")) {
          return;
        }
        update.classList.add("working");
        err.style.display = "none";
        const req: ApiUserUpdate = {
          name: name_input.value
        }
        Ajax.post("/api/v1/user_update", function (data: ApiUser) {
          if (App.user) {
            App.user.name = data.name;
          }
          name_el.innerText = data.name;
          Overlay.close();
          App.render();
        }, req, function (_code: number, data: ApiErrorResponse) {
          update.classList.remove("working");
          if (data.message !== undefined) {
            err.style.display = "block";
            err.innerText = data.message;
          }
        })
      }

      name_input.focus();
    }

    const email_section = Settings.edit_section("Email");
    d.appendChild(email_section);

    const email_el = div();
    email_el.innerText = user.email;
    email_section.appendChild(email_el);
    const email_link = anchor("inline-block");
    email_link.innerText = "Change email";
    email_section.appendChild(email_link);

    email_link.onclick = function () {
      const body = div("overlay-body");
      new Overlay(OverlayStyle.Viz, "Change Email", [body], "", function () {
        //
      });

      const f = form();
      const email_input = Auth.input("Email", "false", "text", "");
      email_input.value = user.email;
      f.appendChild(email_input);

      const pass_input = Auth.input("Password", "false", "password", "");
      f.appendChild(pass_input);

      const err = div("error");
      err.style.display = "none";
      f.appendChild(err);

      const button_container = div("r-align");
      const update = button("key");
      button_container.appendChild(update);
      update.setAttribute("type", "submit");
      update.innerText = "Update";
      const loading = Loading.overlay();
      update.appendChild(loading);
      f.appendChild(button_container);
      body.appendChild(f);

      f.onsubmit = function (e) {
        e.preventDefault();
        if (update.classList.contains("working")) {
          return;
        }
        err.style.display = "none";
        update.classList.add("working");
        const req: ApiChangeEmailRequest = {
          email: user.email,
          password: pass_input.value,
          new_email: email_input.value,
        }
        Ajax.post("/api/v1/user_email_update", function (data: ApiUser) {
          if (App.user) {
            App.user.email = data.email;
          }
          email_el.innerText = data.email;
          App.render();
          Overlay.close();
        }, req, function (_code: number, data: ApiErrorResponse) {
          update.classList.remove("working");
          if (data.message !== undefined) {
            err.style.display = "block";
            err.innerText = data.message;
          }
        })
      }

      email_input.focus();
    }

    container.appendChild(d);
  }
}